import { GetOptions, AirwallexPayment } from "@/core";
import { ResolveAirwallexPaymentMatchPayload } from "@/core/ports/services/functions-service";
import { repositoryHost } from "@/repositories";
import { serviceHost } from "@/services";
import {
  useInfiniteQuery,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";
import { getNextPageParam } from "../utils/page-params";

const databaseService = serviceHost.getDatabaseService();
const airwallexPaymentRepository =
  repositoryHost.getAirwallexPaymentRepository(databaseService);
const functionsService = serviceHost.getFunctionsService();

export const useAirwallexPayments = (options: GetOptions<AirwallexPayment>) => {
  return useInfiniteQuery({
    queryKey: ["airwallex-payments", "get", JSON.stringify(options)],
    queryFn: ({ pageParam }) =>
      airwallexPaymentRepository.getAll({
        ...options,
        pagination: {
          ...options.pagination,
          cursor: pageParam,
        },
      }),
    initialPageParam: "",
    getNextPageParam: getNextPageParam(options),
  });
};

export const useResolveAirwallexPaymentMatch = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: ResolveAirwallexPaymentMatchPayload) =>
      functionsService.resolveAirwallexPaymentMatch(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["airwallex-payments"] });
      // Matching also creates/removes the context-only Payment on the PO
      // (outgoing) or the sales order's invoice (incoming).
      queryClient.invalidateQueries({ queryKey: ["payments"] });
      queryClient.invalidateQueries({ queryKey: ["purchase-orders"] });
      queryClient.invalidateQueries({ queryKey: ["sales-orders"] });
      queryClient.invalidateQueries({ queryKey: ["invoices"] });
    },
  });
};
